// File: src/pages/account/accountPage.tsx

import React, { useContext } from "react";
import { Container, Typography, Box, SxProps, Theme } from "@mui/material";

// MUI X (v6+) Date Pickers with Day.js
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// Context
import { UserContext } from "../../contexts/user-context";

// Sub-components
import NameField from "./NameUpdate";
import { PhoneField } from "./PhoneField";
import BirthdayField from "./BirthdayUpdate";
import ReadOnlyFields from "./ReadOnlyFields";

// Example MUI styles to keep consistent
export const textFieldSx: SxProps<Theme> = {
  "& .MuiInputBase-root": {
    color: "#fff",
  },
  "& .MuiFormLabel-root": {
    color: "#aaa",
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#aaa",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#fff",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#fff",
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "#fff",
  },
  "& .MuiFormLabel-root.Mui-disabled": {
    color: "#ccc",
  },
  "& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
    borderColor: "#666",
  },
};

const Account: React.FC = () => {
  const userContext = useContext(UserContext);
  if (!userContext) {
    throw new Error(
      "UserContext is undefined. Make sure UserProvider is included."
    );
  }
  const { user, userData, setUserData } = userContext;

  return (
    <Container
      sx={{
        mt: 4,
        mb: 4,
        mx: "auto",
        maxWidth: { xs: "100%", sm: "500px", md: "600px" },
        backgroundColor: "rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(2px)",
        borderRadius: 2,
        p: { xs: 2, md: 4 },
        color: "#fff",
        boxShadow: "0 0 10px rgba(0,0,0,0.3)",
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Typography
          variant="h4"
          mb={4}
          sx={{ fontWeight: "bold", textAlign: "center" }}
        >
          Account Details
        </Typography>

        {/* Name Update Field */}
        <Box mb={3}>
          <NameField
            user={user}
            userData={userData}
            setUserData={setUserData}
            textFieldSx={textFieldSx}
          />
        </Box>

        {/* Phone Field with OTP Verification */}
        <Box mb={3}>
          <PhoneField
            user={user}
            userData={userData}
            setUserData={setUserData}
          />
        </Box>

        <Box mb={3}>
          <ReadOnlyFields userData={userData} textFieldSx={textFieldSx} />
        </Box>

        <Box mb={3}>
          <BirthdayField
            user={user}
            userData={userData}
            setUserData={setUserData}
            textFieldSx={textFieldSx}
          />
        </Box>
      </LocalizationProvider>
    </Container>
  );
};

export default Account;
